import * as React from 'react';
import { Theme } from '@cian/ui-kit';
import * as style from './BasicInfo.css';

export const BasicInfo: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Theme theme="dark">
      <div className={style['container']} data-testid="BasicInfo">
        <div className={style['basic-info']}>{children}</div>
      </div>
    </Theme>
  );
};
